import { useEffect, useState } from "react";
import type { CallBackProps } from "react-joyride";

const TOUR_STORAGE_KEY = "hasViewedUsageAndBillingTour";

export function useUsageAndBillingTour() {
  const [runTour, setRunTour] = useState(false);

  useEffect(() => {
    const hasViewedTour = localStorage.getItem(TOUR_STORAGE_KEY);
    if (!hasViewedTour) {
      setRunTour(true);
    }
  }, []);

  const handleJoyrideCallback = ({ status }: CallBackProps) => {
    if (["finished", "skipped"].includes(status)) {
      setRunTour(false);
      localStorage.setItem(TOUR_STORAGE_KEY, "true");
    }
  };

  return { runTour, setRunTour, handleJoyrideCallback };
}
